<template>
  <div>
    <a-modal :visible="true" title="Associate unit" width="600px" okText="Save" @cancel="closeModal" @ok="submit" class="addUnitModal">
      <a-spin :spinning="Status === 'addingUnit'">
        <label> Parent:</label>
        <a-input :value="selectedUnit.title" :disabled="true" />
        <a-form :form="form" class="buisnessUnitTypes">
          <a-form-item>
            <label> Client:</label>
            <a-select v-decorator="['id', { rules: [{ required: true, message: 'Please select a clent!' }] }]">
              <a-select-option v-for="client in Clients" :value="client.id" :key="client.id">
                {{ client.name }}
              </a-select-option>
            </a-select>
          </a-form-item>
          <a-form-item>
            <label>Unit type:</label>
            <a-select v-decorator="['unitType', { rules: [{ required: true, message: 'Please select a Unit Type!' }] }]">
              <a-select-option v-for="unitType in UnitTypes" :value="unitType.unit_type_id" :key="unitType.unit_type_id">
                {{ unitType.unit_type_name }}
              </a-select-option>
            </a-select>
          </a-form-item>
        </a-form>
      </a-spin>
    </a-modal>
  </div>
</template>

<script>
import { mapState } from 'vuex';

export default {
  name: 'AssociateUnit',
  props: { selectedUnit: Object },
  data() {
    return {
      form: this.$form.createForm(this, { name: 'AssociateUnitForm' }),
    };
  },
  methods: {
    closeModal() {
      this.$store.dispatch('businessUnits/updateOpenModal', '');
    },
    submit() {
      this.form.validateFields((errors, { id, unitType }) => {
        if (!errors) {
          this.$store
            .dispatch(`businessUnits/associateUnit`, {
              id,
              parent_id: this.selectedUnit.key,
              customer_id: this.Customer.customerid,
              unit_type_id: unitType,
            })
            .then(() => {
              this.$store.dispatch('businessUnits/getTree', this.Customer.customerid);
              this.closeModal();
            });
        }
      });
    },
  },

  computed: {
    ...mapState({
      UnitTypes: (state) => state.businessUnits.UnitTypes,
      Status: (state) => state.businessUnits.Status,
      Customer: (state) => state.businessUnits.Customer,
      Clients: (state) => state.businessUnits.Clients,
    }),
  },
};
</script>
<style lang="scss">
.addUnitModal {
  @mixin form-field {
    background-color: #f0f9ff !important;
    height: calc(1.5em + 1rem);
    border-radius: 0.4rem;
    border: 0 solid #ced4da !important;
    box-shadow: inset 1px 1px 3px rgb(157 193 216 / 50%);
    transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
  }
  .ant-spin-container {
    & > .ant-input {
      width: 100%;
      min-width: 20px;
      @include form-field();
      margin-bottom: 10px;
    }
    .buisnessUnitTypes {
      .ant-form-item {
        margin-bottom: 10px;
        .ant-form-item-children {
          .ant-select,
          & > .ant-input {
            width: 100%;
            min-width: 20px;
          }
          .ant-select-selection.ant-select-selection--single,
          & > .ant-input {
            @include form-field();
            .ant-select-selection__rendered {
              line-height: 36px;
            }
          }
        }
      }
    }
  }
}
</style>
